<template>
    <div>
        <div class="loading-spinner" v-if="!pointLogs.data">
            <base-spinner></base-spinner>
        </div>
         <!-- 항목 테이블 -->
        <div class="tbl_wrap" v-if="pointLogs.data">
            <table class="tbl">
                <colgroup>
                <col style="width:5%" />
                <col style="width:45%" />
                <col style="width:10%" />
                <col style="width:15%" />
                <col style="width:15%" />
                <col style="width:10%" />
                </colgroup>
                <thead>
                <tr>
                    <th>번호</th>
                    <th>내역</th>
                    <th>유저</th>
                    <th>포인트</th>
                    <th>결과포인트</th>
                    <th>날짜</th>                    
                </tr>
                </thead>
                <tbody>
                <template v-if="pointLogs.data.length ===0">
                    <tr><td colspan="6">작성한 게시글이 없습니다.</td></tr>
                    
                </template>
                    <template v-else>
                        <tr v-for="(log, index) in pointLogs.data" :key="index">
                            <td>{{pointLogs.total - pointLogs.from + 1 - index}}</td>
                            <td class="article_title">{{log.act}}</td>
                            <td class="article_writer">{{log.user.nic}}</td>                          
                            <td>{{log.point}}</td>
                            <td>{{log.result_point}}</td>
                            <td><display-time :time="log.created_at"/></td>
                        </tr>   
                    </template>

                </tbody>
            </table>
            <paginate store="point" collection="pointLogs"  @paging="fetchLists"/>
        </div>
        <!-- 항목 테이블 -->
    </div>
</template>
<script>
import DisplayTime from '@/components/site/parts/DisplayTime.vue'
import Paginate from '@/components/site/parts/PaginatePublic.vue'
export default {
    data(){
        return{
            isLoading:true
        }
    },
    components:{
        DisplayTime,
        Paginate       
    }, 
    mounted(){
        this.fetchLists();
    },
    computed:{
        pointLogs:{            
            get(){                 
                return this.$store.state.point.pointLogs;
            }
        },
    },
    methods:{
        test(data){
            alert(data);
        },
        async fetchLists(pagenumber) {
            const formData = {               
                user_id:this.$store.getters.currentUser.id,
                getmypost:true,
                page:pagenumber?pagenumber:1
            }
            try {
                const response = await this.$store.dispatch("point/getPointLogs", formData)
                //console.log(response);
                this.pointLogs = response.data.reverse();
                //console.log("안나오는듯",this.postlists.data.length);          
            }catch(error){
                console.log(error.response);
            }
            this.isLoading = false;
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/table';
</style>
